import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";

export const PRODUCTS_WITH_SUMMER_DISCOUNT: INSURANCE_NAME_VALUE[] = [
  INSURANCE_NAME_VALUE.CARAVAN,
  INSURANCE_NAME_VALUE.BOAT,
  INSURANCE_NAME_VALUE.TRAVEL,
  INSURANCE_NAME_VALUE.MOTORCYCLE,
  INSURANCE_NAME_VALUE.ELECTRIC_SCOOTER,
];
